import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const emergencyMessageSettingsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "emergency-messaging",
}).lazy(() => import("./EmergencyMessageSettings.lazy").then((d) => d.Route));
